import Section from "@/lib/Section";
import {Question} from "@/lib/Question";
import {ArraySectionItem} from "./ArraySectionItem";
import store from "../store";
import Response from "./Response";

export class ArrayQuestion {
    public label: string = '';
    public description: string = '';
    public questions: Question[] = [];
    constructor(question: Question, arraySectionItems: ArraySectionItem[] = []) {
        this.label = question.label;
        this.description = question.description;
        arraySectionItems.forEach((arraySectionItem: ArraySectionItem) => {
            const additionalQuestion = Section.createAdditionalQuestionFromArraySectionItem(question, arraySectionItem);
            let currentResponse = store.state.responses.find((response: Response) => {
                return response.question.id == additionalQuestion.originalId &&
                    (response.responseGroup.id == store.state.currentResponseGroup.id) &&
                    response.additionalIndex == arraySectionItem.additional.additionalIndex;
            });

            if (currentResponse) {
                additionalQuestion.loadingFromServer(currentResponse);
                // additionalQuestion.currentResponse = currentResponse;
                currentResponse.question = additionalQuestion;
            }
            this.questions.push(additionalQuestion);
        });
    }

}
